import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../infrastructure/services/auth.service';
import { SxSecurityService } from '../../infrastructure/services/sxSecurity.service';
import { ConfigService, RootConfigurationItem } from 'app/infrastructure/services/config.service';

@Component({
  selector: 'app-desktop',
  templateUrl: './users-soc.component.html'
})
export class UsersSocComponent implements OnInit {
  itemOver: string;
  
  currentUser = this.authService.currentUser;
  commands: RootConfigurationItem[];

  canAccessUserAdmin :boolean =false;
  canAccessUserProfileAdmin:boolean=false;
  canAccessUserProfiles:boolean=false;
  canAccessUserAtributeDesigner:boolean=false;
  canAccessUserAtributes:boolean=false;
  canAccessUserPolicies:boolean=false;

  constructor(public authService: AuthService,
    public securityService: SxSecurityService,
    public configService: ConfigService) { }

  ngOnInit() {
    this.configService.getRootUserManagementConiguration()
    .subscribe(x=> {

      this.commands=x;
      if(this.commands.find(x=> x.descriptionCode== 'ACCESS_ROOT_USER_ADMIN')){
        this.canAccessUserAdmin = true;
      }
      if(this.commands.find(x=> x.descriptionCode=='ACCESS_ROOT_USER_PROFILE_ADMIN')){
        this.canAccessUserProfileAdmin = true;
      }
      if(this.commands.find(x=> x.descriptionCode=='ACCESS_ROOT_USER_PROFILES' )){
        this.canAccessUserProfiles = true;
      }
      if(this.commands.find(x=> x.descriptionCode=='ACCESS_ROOT_USER_ATRIBUTE_DESIGNER')){
        this.canAccessUserAtributeDesigner = true;
      }
      if(this.commands.find(x=> x.descriptionCode== 'ACCESS_ROOT_USER_ATRIBUTE')){
        this.canAccessUserAtributes = true;
      }
      if(this.commands.find(x=> x.descriptionCode== 'ACCESS_ROOT_USER_POLICIES')){
        this.canAccessUserPolicies = true;
      }
    });
  }

  logout() {
    this.securityService.logout();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/users-soc/user-soc.component.ts